// @ts-nocheck
import { useMemo } from 'react';
import { Menu, MenuItem, Typography, IconButton, Stack, Tooltip } from '@mui/material';
import Iconify from 'src/components/Iconify';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';

export type ContextMenuItemType<T> = {
  id?: string;
  label?: string;
  icon?: string;
  onPress?: (entity: T, triggers: any) => void;
  // TODO: rename to `visible`
  rules?: (entity: T) => boolean;
  disabled?: boolean | ((entity: T) => boolean);
};

type ContextMenuItemProps<T> = {
  icon?: string;
  entity: T;
  color?: string;
  items: ContextMenuItemType<T>[];
};

function EntityContextMenu<T>({ icon = 'eva:more-vertical-fill', items, entity, color = '#637381' }: ContextMenuItemProps<T>) {
  const popupState = usePopupState({ variant: 'popover', popupId: 'add-entity-modal' });
  const triggers = useMemo(() => bindTrigger(popupState), [popupState]);

  return (
    <>
      <IconButton {...triggers}>
        <Iconify color={color} icon={icon} />
      </IconButton>
      <Menu
        {...bindMenu(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items
          .filter((item) => (item.rules ? item.rules(entity) : true))
          .map((item) => (
            <MenuItem
              key={item.label}
              onClick={() => {
                item.onPress?.(entity, popupState);
                popupState.close();
              }}
              disabled={typeof item.disabled === 'function' ? item.disabled?.(entity) : item.disabled}
            >
              <Stack direction="row" spacing={2}>
                <Iconify icon={item.icon} />
                <Typography variant="body2">{item.label}</Typography>
              </Stack>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}

export default EntityContextMenu;
